import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loader" }

import { IonSpinner } from '@ionic/vue';
    import { useI18n } from 'vue-i18n'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LoaderComponent',
  props: {
        text: {
            type: String,
            default: 'loader.text',
        }
    },
  setup(__props) {
   

    /* imports */
    const { t } = useI18n();

    /* interface */

    /* Reactive */

    /* Props */
    

    /* Lifecycle Hooks */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(IonSpinner), { name: "circular" }),
      _createTextVNode(),
      _createElementVNode("span", null, _toDisplayString(_unref(t)(__props.text)), 1)
    ])
  ]))
}
}

})